module.exports = __webpack_public_path__ + "media/images/fallback/photo/gallery_default-7598980c4ba81d20c7d48968e4155d97.png";